(function (angular, schoolwork12) {

    'use strict';
   
    angular.module(schoolwork12.app.graduationPlan.name)
      .controller(schoolwork12.app.graduationPlan.controllers.manageGraduationPlan, [
        '$rootScope', '$scope', '$timeout', '$http',
         schoolwork12.app.auth.services.authentication,
         schoolwork12.app.common.services.eventNotification,
         schoolwork12.app.common.services.utilService,
         schoolwork12.app.graduationPlan.services.graduationPlanSvc,
        function ($rootScope, $scope, $timeout, $http,
        	authentication, eventNotification, utilService, graduationPlanSvc) {

        	console.info("In graduation plan controller");
            eventNotification.subscribe(schoolwork12.app.auth.events.userLoggedIn,
                function (event, authenticatedUser) {
                    console.info('Graduation Plan controller: Subscribe On UserLogin Event: '
                        .concat(angular.toJson(authenticatedUser)));
                	
                	//fetch role and list of schools when user navigates directly to url
                	$scope.isGradPlanManager  = authentication.hasGradPlanManagerRole();
                	$scope.schoollist = authentication.getSchools();
				
                });

            //Initialize global variables
   			$scope.gradPlan = {};
   			$scope.graduationPlanErrorMesg = "";
			$scope.graduationPlanErrorOccurred = false;	
			$rootScope.closeSuccess = false;
			$rootScope.closeWarning = false;
			
			$scope.isGraduationPlanSearchBusy = false;
			$scope.isSearchDisabled = false;

            //Get list of schools with grad plan turned on 
            var getGradPlanSchools = function() {
            	$scope.schoollist = authentication.getSchools();
	            $scope.gradPlanSchools = $scope.schoollist.filter(function (obj) { 
	              return obj.isGradPlanOn === true; 
	            });
			    $scope.gradPlan.schools = $scope.gradPlanSchools;

			    if (!$scope.gradPlan.selectedSchool) {
			      $scope.gradPlan.selectedSchool = $scope.gradPlan.schools[0];
			    }

			    $rootScope.gradPlanOnSchools =  $scope.gradPlan.schools;
			    $rootScope.selectedGradPlanSchool = $scope.gradPlan.selectedSchool;
            }
         
           	//fetch grad plan schools when page is refreshed
            if(authentication.isAuthenticated()) {	
            	console.info("Keycode found, fetch list of schools");
            	getGradPlanSchools();

           	} else {
                $timeout(function () {
                	console.info("Keycode not found, fetch list of schools");
               		getGradPlanSchools();
                }, 500);

            };

            //close success msg on click
            $scope.closeSuccessMsg = function() {
            	$rootScope.closeSuccess = true;
            }

            //close warning msg on click
            $scope.closeWarningMsg = function() {
            	$rootScope.closeWarning = true;
            }

            //Initialize manage grad plan grid 
             $scope.gridOptions = {
		     	rowHeight: 50,
				paginationPageSizes : [ 25, 50, 75 ],
				paginationPageSize : 25,
		    };
		   
		    //Custom cell template to indicate default diploma
		    var diplomaCellTemplate = '<div class="ui-grid-cell-contents"> {{grid.getCellValue(row, col)}}' +  
		    '<span ng-show="row.entity.defaultDiploma == true"> - <span class="label label-default"> Default Plan </span></span>' + 
		    '</div>';

		    var createdOnCellTemplate = '<div class="ui-grid-cell-contents actionIcons"> {{grid.getCellValue(row, col)}}' +  
		    '</div>';

		     var actionCellTemplate = '<div class="ui-grid-cell-contents actionIcons" ui-sref="graduationPlan.editSchoolPlan({ id: row.entity.id, diploma: row.entity.name })">' +  
		    '<span class="glyphicon glyphicon-edit" tooltip-placement="bottom" uib-tooltip="Edit School Graduation Plan"></span>' + 
		    '</div>';

		    //Build column definitions	
			$scope.gridOptions.columnDefs = [
			    { field: 'name', displayName: 'Graduation Plan', width: '60%', cellTemplate: diplomaCellTemplate},
			    { field: 'createDate', displayName: 'Created On', cellTemplate: createdOnCellTemplate, 
			    sort: {direction: 'desc'}, sortingAlgorithm: utilService.sortDateFn},
			    { field: 'action', displayName: 'Action',  width: '15%', cellTemplate: actionCellTemplate},
			];

			//Get graduation plan for selected school
			$scope.getGraduationPlanList = function(){
			   var graduationPlanPromise = null;
			   $scope.displayGraduationPlanGrid = false;
			   $scope.isGraduationPlanSearchBusy = true;
			   $scope.isSearchDisabled = true;
			   var getGraduationPlanListSvc = function(){
			   	 graduationPlanPromise = graduationPlanSvc.getAllGraduationPlans(authentication.getCurrentUser().keycode, $scope.gradPlan.selectedSchool.schoolId);
	                graduationPlanPromise
	                .then(
	                		function (data) { 
							if (data.length > 0) {
								console.info("Viewing graduation plans grid");  
								$scope.graduationPlanErrorOccurred = false;
								$scope.graduationPlanErrorMesg = " ";   
								$scope.displayGraduationPlanGrid = true;
			             	    $scope.gridOptions.data = data;

							} else {
								$scope.graduationPlanErrorOccurred = true;
								$scope.graduationPlanErrorMesg = schoolwork12.app.errorMessages.noResultsFound;
							}
		             	 
	                }, function (error) {
	                    console.info('Error in viewing graduation plans grid....'.concat(angular.toJson(error)));   
	                    $scope.graduationPlanErrorOccurred = true;
	                	if (error.status == 400) {
							for ( var j = 0; j < error.data._errors.length; j++) {
								$scope.graduationPlanErrorMesg = $scope.graduationPlanErrorMesg + error.data._errors[j] + "\n";
							}
						} else if (error.status == 401 || error.status == 403) {
	                        $scope.graduationPlanErrorMesg = schoolwork12.app.errorMessages.sessionExpired;
	                    } else {
	                        $scope.graduationPlanErrorMesg = schoolwork12.app.errorMessages.internalError;
	                    }

	                })['finally']
					(function() {
						$scope.isGraduationPlanSearchBusy = false;
						$scope.isSearchDisabled = false;
					});
			    }

	           $scope.isGraduationPlanSearchBusy = true;
	            if (typeof (authentication.getCurrentUser()) != 'undefined' && authentication.getCurrentUser() != null) {
	                console.info('Keycode found. Making a call to service');
	                //invoking getGraduationPlanListSvc()
	                getGraduationPlanListSvc();
	            } else {
	                console.info('Key code not found. Using time out function to make a call');
	                $timeout(function () {
	                //invoking getGraduationPlanListSvc()
	                getGraduationPlanListSvc();
	                }, 500);
	            };
        	};


    }]);

}(angular, schoolwork12));